module.exports = __webpack_public_path__ + "img/Textured Lavender.36c784e7.jpg";